import { render } from "./AdminCityEdit.vue?vue&type=template&id=04f48642&scoped=true&ts=true&lang=true"
import script from "./AdminCityEdit.vue?vue&type=script&lang=ts"
export * from "./AdminCityEdit.vue?vue&type=script&lang=ts"

import "./AdminCityEdit.vue?vue&type=style&index=0&id=04f48642&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f48642"]])

export default __exports__